import React, { useContext } from "react";
import { ProfileNameWrapper } from "./Styled";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";

const ProfileName = () => {
    const { user } = useContext(AuthenticationContext);
    
    return (
        <ProfileNameWrapper>
            {user.avatar ? (
                <img 
                    src={user.avatar} 
                    alt={user.display_name}
                    style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', border: '1px solid #e5e7eb' }}
                />
            ) : (
                <div style={{ 
                    width: '32px', 
                    height: '32px', 
                    borderRadius: '50%', 
                    backgroundColor: '#9C27B0', 
                    color: 'white', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: 'bold'
                }}>
                    {(user.display_name || 'U')[0].toUpperCase()}
                </div>
            )}
            <span>{user.display_name || "User"}</span>
        </ProfileNameWrapper>
    );
};

export default ProfileName;
